import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import { styled } from "@mui/material/styles";
import styles from "../assets/jss/material-dashboard-react/components/cardBodyStyle.js";

// Styled root component
const CardBodyRoot = styled("div", {
  shouldForwardProp: (prop) => prop !== "plain" && prop !== "profile"
})(({ plain, profile }) => ({
  ...styles.cardBody,
  ...(plain && styles.cardBodyPlain),
  ...(profile && styles.cardBodyProfile),
}));

export default function CardBody(props) {
  const { className, children, plain, profile, ...rest } = props;

  return (
    <CardBodyRoot
      className={classNames(className)}
      plain={plain ? 1 : 0}
      profile={profile ? 1 : 0}
      {...rest}
    >
      {children}
    </CardBodyRoot>
  );
}

CardBody.propTypes = {
  className: PropTypes.string,
  plain: PropTypes.bool,
  profile: PropTypes.bool,
  children: PropTypes.node,
};
